import { TableCell, TableRow, Typography } from "@mui/material";

export const EmptyList = () => {
  return (
    <TableRow>
      <TableCell colSpan={999} sx={{ textAlign: "center", height: "460px" }}>
        <Typography>No data available!</Typography>
      </TableCell>
    </TableRow>
  );
};
